<p-orderList id="template" 
             [value]="tiposOs" 
             i18n-header
             header="Tipo de Serviços" 
             filterBy="resumoTipoOs"
             filter="filter"
             i18n-filterPlaceholder 
             filterPlaceholder="Buscar tipo de serviços...">           
  <ng-template let-tipoOS pTemplate="item">   
      <div class="ui-helper-clearfix" (click)="selecionarTipoOS(tipoOS)">
          <img src="assets/images/tipoos.png" style="display:inline-block;margin:2px 0 2px 2px" width="48" />
          <div style="font-size:14px;float:right;margin:15px 5px 0 0" >{{tipoOS.resumoTipoOs}}</div>
      </div>
  </ng-template>
</p-orderList>
